import React, { useState } from 'react';
import { ExternalLink } from 'lucide-react';

export interface GridItemProps {
  id: number;
  tab_name: string;
  imageUri: string;
  onClick: () => void;
}

const GridItem: React.FC<GridItemProps> = ({
  id,
  tab_name,
  imageUri,
  onClick
}) => {
  const [isHovered, setIsHovered] = useState<number | null>(null);

  return (
    <button
      className="w-full aspect-square rounded-[30px] bg-grid dark:bg-darkCardBackground p-[8%] border border-gray-200 dark:border-gray-700 relative flex flex-col justify-start overflow-hidden box-border mx-auto will-change-transform transform-gpu backface-hidden transition-all duration-200 ease-out hover:-translate-y-0.5 active:scale-[0.98] backdrop-blur-sm"
      onMouseEnter={() => setIsHovered(id)}
      onMouseLeave={() => setIsHovered(null)}
      onClick={onClick}
    >
      {/* Top Row */}
      <div className="w-full flex flex-row items-start justify-between gap-1 mb-4">
        <p className="text-slate-700 dark:text-white text-sm md:text-base flex-1 m-0 overflow-hidden text-left font-light leading-tight line-clamp-3">
          {tab_name}
        </p>
        <div className="w-8 h-8 bg-white dark:bg-darkCardBackground rounded-full flex items-center justify-center ml-2">
          <svg 
            width="48" 
            height="48" 
            viewBox="0 0 32 32" 
            fill="none"
          >
            <path
              fill="currentColor"
              className="text-gray-600 dark:text-gray-400"
              d="m22.22 22.33.1-11.7c-2.93.03-8.77.07-11.7.1l-.03 1.47c2.63-.03 6.13-.05 9.21-.07l-9.6 9.6 1.03 1.03 9.6-9.6-.08 9.21 1.47-.01v-.03Z"
            />
          </svg>
        </div>
      </div>

      {/* Image Container */}
      <div
        className={`flex flex-1 h-[95%] aspect-square pt-[15%] self-end relative items-end justify-end will-change-transform transition-transform duration-300 ease-out transform-gpu backface-hidden ${
          isHovered === id ? "scale-102" : "scale-100"
        }`}
      >
        <img
          src={imageUri}
          alt={tab_name}
          className="w-4/5 h-4/5 absolute object-contain md:w-full md:h-full"
          onError={(e) => {
            const target = e.target as HTMLImageElement;
            target.src = "/placeholder.svg?height=80&width=80&text=Error";
          }}
        />
      </div>
    </button>
  );
};

export default GridItem; 